/* eslint-disable @typescript-eslint/naming-convention */

import { baseGlobals } from '@root/typescript/baseGlobals'

import type {
  IMusic, TSerial, TEngine, IImprint, TSfxTheme,
  TDevPhase, TLanguages, TDemoStatus, TRestrictions
} from './definitions'

declare const __LANGS__: TLanguages
declare const __LOCALES__: string
declare const __APP__: string
declare const __ENGINE__: TEngine
declare const __RESTRICTIONS__: TRestrictions
declare const __FONTS__: readonly string[]
declare const __ACTIVATOR__: boolean
declare const __SERIAL__: TSerial
declare const __USE_BUILT_IN_FONTS__: boolean
declare const __PRELOADER_BASE64__: string
declare const __DEMO_STATUS__: TDemoStatus
declare const __DEV_PHASE__: TDevPhase
declare const __ELECTRON__: boolean
declare const __CORDOVA__: boolean
declare const __APP_LOCALES__: string
declare const __BASE_FONTS__: readonly string[]
declare const __BUILD_TYPE__: 'electron' | 'cordova' | 'web'
declare const __BUILD_TIME__: string
declare const __DEVELOPER__: string
declare const __IMPRINT__: IImprint
declare const __UPDATE_LINK__: string
declare const __VERSION__: number
declare const __SFX_THEME__: TSfxTheme
declare const __MUSIC__: IMusic | false
declare const __NEED_LOADING_SCREEN__: boolean

interface IGlobals {
  engine: TEngine
  useBuiltInFonts: boolean
  preloaderBase64: string
  restrictions: TRestrictions
  demoStatus: TDemoStatus
  devPhase: TDevPhase
  appLocales: string
  baseFonts: readonly string[]
  buildType: 'electron' | 'cordova' | 'web'
  buildTime: string
  isActivator: boolean
  isElectron: boolean
  isCordova: boolean
  developer: string
  imprint: IImprint
  locales: string
  fonts: readonly string[]
  languages: TLanguages
  app: string
  isProd: boolean
  serial: TSerial
  isTest: boolean
  isDev: boolean
  updateLink: string
  version: number
  sfxTheme: TSfxTheme
  music: IMusic | false
  needLoadingScreen: boolean
}

const globals: IGlobals = {
  ...baseGlobals,
  languages: __LANGS__,
  serial: __SERIAL__,
  restrictions: __RESTRICTIONS__,
  app: __APP__,
  engine: __ENGINE__,
  fonts: __FONTS__,
  locales: __LOCALES__,
  isActivator: __ACTIVATOR__,
  updateLink: __UPDATE_LINK__,
  version: __VERSION__,
  useBuiltInFonts: __USE_BUILT_IN_FONTS__,
  preloaderBase64: __PRELOADER_BASE64__,
  demoStatus: __DEMO_STATUS__,
  devPhase: __DEV_PHASE__,
  appLocales: __APP_LOCALES__,
  baseFonts: __BASE_FONTS__,
  buildType: __BUILD_TYPE__,
  buildTime: __BUILD_TIME__,
  isElectron: __ELECTRON__,
  isCordova: __CORDOVA__,
  developer: __DEVELOPER__,
  imprint: __IMPRINT__,
  sfxTheme: __SFX_THEME__,
  music: __MUSIC__,
  needLoadingScreen: __NEED_LOADING_SCREEN__
}

export default globals
